import MoveQuestionnaire from './pages/move/MoveQuestionnaire';

export default function MoveApp() {
  const m = window.location.pathname.match(/^\/move\/([^/]+)/);
  return <MoveQuestionnaire token={m ? m[1] : ''} />;
}
